import {IconProps} from "./index";
import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';


export interface CheckBoxIconProps extends IconProps {
    isChecked?: boolean;
    isIndeterminate?: boolean;
    className?: string;
}

export const CheckBoxIcon = React.forwardRef<HTMLElement, MuiIconExternalProps & CheckBoxIconProps>(
    ({isChecked, isIndeterminate, className, ...props}, ref) => {
        let iconCode: string;

        if (isIndeterminate) {
            iconCode = '\ue909';
        } else if (isChecked) {
            iconCode = '\ue834';
        } else {
            iconCode = '\ue835';
        }

        return (
            <MuiIcon
                className={className}
                {...props}
                ref={ref}
            >
                {iconCode}
            </MuiIcon>
        );
    }
);

